import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { UserCommentsGateway } from '../../gateways/user-comments-gateway'
import { WebUserComment } from '../../models/web-user-comments'
import {PortalGlobals} from '../../../portalglobals'

@Component({
    selector: 'UserComments',
    templateUrl: 'user-comments.component.html'
})

export class UserCommentsComponent implements OnInit {
    @Input()
    commentsViewModel: WebUserComment[]
    CommentinsertModel: WebUserComment
    public userProfileID: number
    errorMessage: string
    @Output() onCommentAdded: EventEmitter<WebUserComment> = new EventEmitter<WebUserComment>()

    constructor(
        private userCommentsGateway: UserCommentsGateway,
        public _global: PortalGlobals
    ) {
        this.commentsViewModel = {} as WebUserComment[]
        this.CommentinsertModel = {} as WebUserComment
    }

    ngOnInit(): void {

        // this.getFormData()
    }

    submitForm(): void {
        // this.userCommentsGateway.addUsercomments(this.CommentinsertModel).subscribe(
        //    (model: WebUserComment) => {
        //        this.CommentinsertModel = model
        //    }

        // )
        // this.getFormData()
        if (this.CommentinsertModel.Comment !== '' && this.CommentinsertModel.Comment !== undefined) {
            this.onCommentAdded.emit(this.CommentinsertModel)
            this.CommentinsertModel.Comment = ''
            this.errorMessage = ''
        } else {
            this.errorMessage ="No comment entered. Comment not saved."
        }
    }

     getFormData(): void {

         this.userCommentsGateway.getUserCommentsData(this.userProfileID).subscribe(
            (model: WebUserComment[]) => {
                this.commentsViewModel = model
            }
        )
     }

  }
